import { isLocked } from "app/common/services/pageClaims";
import { swSettings } from "app/common/services/swSettings";
import { GrowthbookService, TestsNames } from "app/services/trackingServices/GrowthBookService";
import { isNoTouch, isTrialOrAfterTrialUser } from "app/UtilitiesAndConstants/UtilityFunctions/usersUtils";

export const canSeeWebsiteContentLockedDummyPage = (): boolean =>
    isLocked(swSettings.components.WsWebWebsiteContent) &&
    GrowthbookService.growthbookInstance.isOn(TestsNames.TOUCH_HOOKS_DUMMY_PAGE) &&
    (isNoTouch(swSettings) || isTrialOrAfterTrialUser(swSettings));
